// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--3-KcA","body":"body--3h0o6"};